import { render, staticRenderFns } from "./DetalharUsoPerfilDialog.vue?vue&type=template&id=5018879a&scoped=true"
import script from "./DetalharUsoPerfilDialog.vue?vue&type=script&lang=js"
export * from "./DetalharUsoPerfilDialog.vue?vue&type=script&lang=js"
import style0 from "./DetalharUsoPerfilDialog.vue?vue&type=style&index=0&id=5018879a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5018879a",
  null
  
)

export default component.exports